import { createContext, useContext, type ReactNode } from 'react';
import type { UseIntakeSessionReturn } from './useIntakeSession';

const IntakeSessionCtx = createContext<UseIntakeSessionReturn | null>(null);

export function IntakeSessionProvider({
  value,
  children,
}: {
  value: UseIntakeSessionReturn;
  children: ReactNode;
}): JSX.Element {
  return <IntakeSessionCtx.Provider value={value}>{children}</IntakeSessionCtx.Provider>;
}

export function useIntakeSessionContext(): UseIntakeSessionReturn {
  const ctx = useContext(IntakeSessionCtx);
  if (!ctx) {
    throw new Error('useIntakeSessionContext must be used within IntakeSessionProvider');
  }
  return ctx;
}
